import { useJsApiLoader } from '@react-google-maps/api'

// Single source of truth for Google Maps script loading across the app.
// `@react-google-maps/api` requires a stable `libraries` array reference and a
// shared `id` — otherwise each consumer tries to inject the script again,
// producing "Element with name 'gmp-internal-*' already defined" errors and
// corrupting Google Maps internals (Cannot read properties of undefined
// reading 'Wp' / 'WN' / 'PJ').
// The browser key. It ships in the page, so it must be restricted in Google
// Cloud to this site's referrers (docs/GOOGLE_MAPS.md); a build can supply its
// own with REACT_APP_GOOGLE_MAPS_API_KEY (e.g. a localhost-only key for
// development). The literal is today's production key, kept as the default so
// an existing deployment keeps working until it sets the variable.
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyB5tJoqXRnE9UB7t12IoSQVtlzTPTF098s'

// The project's Map ID (a vector map with Advanced Markers). Every map uses it.
export const GOOGLE_MAP_ID = process.env.REACT_APP_GOOGLE_MAP_ID || 'f40294b0b5d0156ce6bcda03'

// Union of every library used anywhere in the app.
export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry', 'marker']

const GOOGLE_MAPS_SCRIPT_ID = 'yum-google-maps-script'

export const useGoogleMaps = () =>
  useJsApiLoader({
    id: GOOGLE_MAPS_SCRIPT_ID,
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES
  })
